import { QueryClient } from "@tanstack/react-query";
import { ErroDaApi } from "../http/erro-da-api";

/**
 * Configuracao do React Query.
 *
 * O ponto que importa: NAO repetir requisicao que falhou por validacao,
 * autorizacao ou recurso inexistente. O padrao da biblioteca e repetir 3 vezes,
 * o que transforma um 403 em quatro 403 e polui o log sem chance de sucesso.
 */
export function criarClienteDeConsulta(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (tentativas, erro) => {
          if (erro instanceof ErroDaApi && !erro.valeRepetir) return false;
          return tentativas < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
